<template>
  <div class="menu-nav pt-0" :id="item.title">
    <div class="menu-section w-100 ma-0 menu-title">
      <inline-svg width="40px" height="40px" class="px-1" :src="item.svg" />
      <h2 class="font-weight-bolder pt-1">{{ $t(item.title) }}</h2>
    </div>
    <v-list class="mt-4 px-5 poppins font-weight-medium">
      <template v-for="group in item.entities">
        <v-list-group v-if="group?.items" :key="group.title" no-action>
          <template v-slot:activator v-if="group.items.length">
            <v-list-item-content>
              <v-list-item-title
                v-text="$t(group.title)"
                class="menu-item text-dark-50 font-weight-bolder"
              />
            </v-list-item-content>
          </template>

          <template>
            <v-list-item
              v-for="child in group.items"
              :key="child.title"
              :to="{ name: child.name }"
              exact
              class="menu-link"
              :class="{ 'bg-light-info': activeSubmenu === child.name }"
              @click="
                () => {
                  $router.push({ name: child.name });
                  activeSubmenu = child.name;
                  hideSideBar();
                }
              "
            >
              <!--  plus nav item for unsubscribed users                  style="color: #c5caec !important;"-->
              <span class="position-relative menu-text ms-3">
                {{ $t(child.title) }}
                <span v-if="isBetaItem(child.name)" class="beta-sup-badge ms-1">
                  BETA
                </span>

                <!--                <inline-svg-->
                <!--                  class="position-absolute purple-plus-star"-->
                <!--                  style="width: 16px; top: -6px; right: -14px"-->
                <!--                  src="/img/plus/plus_star.svg"-->
                <!--                />-->
              </span>
            </v-list-item>
          </template>
        </v-list-group>

        <!--   No need for submenu type, cos it is for default one and that's in other component    -->
        <v-list-item
          v-else
          :key="group?.title"
          :to="{ name: group.name }"
          exact
          class="menu-link position-relative"
          :class="{ 'bg-light-info': activeSubmenu === group.name }"
          @click="
            () => {
              $router.push({ name: group.name });
              activeSubmenu = group.name;
              hideSideBar();
            }
          "
        >
          <span class="position-relative menu-text">
            {{ $t(group.title) }}
            <span v-if="isBetaItem(group.name)" class="beta-sup-badge ms-1">
              BETA
            </span>
          </span>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import eventBus from "@/core/services/eventBus";
export default {
  name: "NaviDropDown",
  props: ["item"],
  data: () => ({
    activeSubmenu: null,
    betaItems: ["dashboard.dashboardAnalyticsBeta"],
  }),
  methods: {
    isBetaItem(name) {
      return this.betaItems.includes(name);
    },
    hideSideBar() {
      eventBus.$emit("toggleAside");
    },
  },
};
</script>

<style scoped lang="scss">
.beta-sup-badge {
  font-size: 9px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #7322b0, #c32c80);
  padding: 2px 6px;
  border-radius: 8px;
  line-height: 1;
  margin-top: 0px;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 4px rgba(195, 44, 128, 0.4);
}

.purple-plus-star {
  //color: #7e8299 !important;
  //svg {
  fill: #90f !important;
  //}
}

.light-gray-plus-star {
  //color: #c5caec !important;
  //svg {
  fill: #c5caec !important;
  //}
}
</style>
